module.exports = __webpack_public_path__ + "img/beneficios.1b839bef.png";